// ITEM 목록 불러오기
export const RECEIVE_ITEMS = "TEAMBLOG_RECEIVE_ITEMS";

// ITEM 클리어
export const CLEAR_ITEMS = "TEAMBLOG_CLEAR_ITEMS";

// 키워드 검색
export const SEARCH_KEYWORD = "TEAMBLOG_SEARCH_KEYWORD";

// 하나의 ITEM 선택 (체크박스)
export const SELECT_ITEM = "TEAMBLOG_SELECT_ITEM";

// 하나의 ITEM 선택 해제 (체크박스)
export const DESELECT_ITEM = "TEAMBLOG_DESELECT_ITEM";

// 모든 ITEM 선택 (전체선택) (리스트의 ITEM 체크)
export const SELECT_ALL_ITEMS = "TEAMBLOG_SELECT_ALL_ITEMS";

// 모든 ITEM 선택 해제 (전체선택 해제) (리스트의 ITEM 선택 해제)
export const DESELECT_ALL_ITEMS = "TEAMBLOG_DESELECT_ALL_ITEMS";

// 하나의 ITEM 의 더보기(more option) 활성화
export const TOGGLE_MORE_BUTTON = "TEAMBLOG_TOGGLE_MORE_BUTTON";

// 하나의 ITEM 의 상태 변경 더보기 활성화
export const TOGGLE_CHANGE_STATUS_BUTTON = "TEAMBLOG_TOGGLE_CHANGE_STATUS_BUTTON";

// 하나의 ITEM 상태 변경
export const UPDATE_ITEM = "TEAMBLOG_UPDATE_ITEM";

// 여러개의 ITEM 상태 변경
export const UPDATE_SELECTED_ITEMS = "TEAMBLOG_UPDATE_SELECTED_ITEMS";

// 여러개의 ITEM 삭제
export const DELETE_SELECTED_ITEMS = "TEAMBLOG_DELETE_SELECTED_ITEMS";

// 하나의 ITEM 삭제
export const DELETE_ITEM = "TEAMBLOG_DELETE_ITEM";

// 권한별 보기
export const FILTER_ROLE = "TEAMBLOG_FILTER_ROLE";

// 대기중 멤버 ITEM 목록 불러오기
export const RECEIVE_WAITING_ITEMS = "TEAMBLOG_RECEIVE_WAITING_ITEMS";
